'use client';

import { Link, ReviewRating as BaseReviewRating } from '@coolblue-development/freddy';
import { HideSystemProps } from '@coolblue-development/freddy/theme';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import type { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';
import { scrollToTarget } from '@utils/utils';

type Props = HideSystemProps & {
  product: Product | MainProduct;
  reviewsSectionId: string;
};

export const EmphasizedReviewRating = ({ product, reviewsSectionId, ...rest }: Props) => {
  const reviewRatingTranslations = useFreddyTranslations('reviewRating');
  const { language } = useRequestContext();

  return (
    <BaseReviewRating
      {...rest}
      sx={{ '> a': { display: 'contents' } }}
      translations={reviewRatingTranslations}
      value={product.reviewMetaData?.averageRating || 0}
      reviewCount={product.reviewMetaData?.count || 0}
      variant='emphasized'
      language={language}
      renderAction={
        product.reviewMetaData?.count && product.reviewMetaData?.count > 0
          ? content => (
              <Link
                href={`#${reviewsSectionId}`}
                onClick={event => {
                  if (product.reviewMetaData?.count) scrollToTarget(reviewsSectionId)(event);
                }}
              >
                {content}
              </Link>
            )
          : undefined
      }
    />
  );
};
